import _slicedToArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import * as React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ReactQueryWrapper = function ReactQueryWrapper(_ref) {
  var children = _ref.children;

  var _React$useState = React.useState(function () {
    return new QueryClient({
      defaultOptions: {
        queries: {
          // With SSR, we usually want to set some default staleTime
          // above 0 to avoid refetching immediately on the client
          staleTime: 60 * 1000
        }
      }
    });
  }),
      _React$useState2 = _slicedToArray(_React$useState, 1),
      queryClient = _React$useState2[0];

  return /*#__PURE__*/_jsxs(QueryClientProvider, {
    client: queryClient,
    children: [children, /*#__PURE__*/_jsx(ReactQueryDevtools, {
      initialIsOpen: false,
      buttonPosition: "bottom-right"
    })]
  });
};
export default ReactQueryWrapper;